import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Maintanance_Mode = () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
  const [toggles, setToggles] = useState({});
  const [menuStatus, setMenuStatus] = useState({});
  const [openMenus, setOpenMenus] = useState({});
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  const menuList = [
    { label: "Dashboard", slug: "dashboard", icon: "fa-house", subMenu: [] },
    {
      label: "Branch Management",
      slug: "branchManagement",
      icon: "fa-code-branch",
      subMenu: [
        { label: "Manage Branch", slug: "managebranch" },
        { label: "Manage Delivery Point", slug: "managedeliverypoint" },
      ],
    },
    {
      label: "Lead Management",
      slug: "leadManagement",
      icon: "fa-people-arrows",
      subMenu: [
        { label: "Manage Lead", slug: "managelead" },
        { label: "Manage Followup", slug: "managefollowup" },
        { label: "Manage Calls", slug: "managecalls" },
        { label: "Manage Coupon", slug: "managecoupon" },
        { label: "Lead Calendar", slug: "leadcalendar" },
        { label: "Lead Source", slug: "leadsource" },
      ],
    },
    {
      label: "Team Management",
      slug: "teamManagement",
      icon: "fa-people-group",
      subMenu: [
        { label: "Team Lead", slug: "team-lead" },
        { label: "Team Followup", slug: "team-followup" },
        { label: "Team Call", slug: "team-call" },
        { label: "Team Promise", slug: "team-promise" },
      ],
    },
    { label: "Subscriber Management", slug: "subscriberManagement", icon: "fa-solid fa-user-tie fs-4", subMenu: [] },
    {
      label: "Subscription Management",
      slug: "subscriptionManagement",
      icon: "fa-money-bill-trend-up",
      subMenu: [
        { label: "Manage Subscription", slug: "manage-subscriptions" },
        { label: "Manage Drop", slug: "manage-drop" },
      ],
    },
    {
      label: "Payments Management",
      slug: "paymentsManagement",
      icon: "fa-money-bill-wave",
      subMenu: [
        { label: "Manage Payments", slug: "payments-management" },
        { label: "Manage Refund", slug: "manage-refund" },
      ],
    },
    {
      label: "Package Management",
      slug: "packageManagement",
      icon: "fa-shapes",
      subMenu: [
        { label: "Manage Items", slug: "manage-items" },
        { label: "Manage Products", slug: "manage-products" },
        { label: "Manage Product Quantity", slug: "manage-product-quantity" },
        { label: "Manage Packages", slug: "manage-packages" },
      ],
    },
  ];

  useEffect(() => {
    fetchCurrentStatus();
  }, []);

  const fetchCurrentStatus = async () => {
    try {
      setInitialLoading(true); // show skeleton
      const res = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
      const data = res.data.data || [];

      const updatedToggles = {};
      menuList.forEach((menu) => {
        updatedToggles[menu.slug] = true;
        menu.subMenu.forEach((sub) => {
          updatedToggles[sub.slug] = true;
        });
      });

      const updatedStatus = {};
      data.forEach((item) => {
        updatedToggles[item.slug] = item.maintenancemode_status === 0;
        updatedStatus[item.slug] = item;
      });

      setToggles(updatedToggles);
      setMenuStatus(updatedStatus);

      const newOpenMenus = {};
      menuList.forEach((menu) => {
        if (menu.subMenu.length > 0) {
          const anyMaintenance = menu.subMenu.some((sub) => !updatedToggles[sub.slug]);
          newOpenMenus[menu.slug] = anyMaintenance;
        }
      });
      setOpenMenus(newOpenMenus);
    } catch (err) {
      console.error(err);
    } finally {
      setInitialLoading(false); // hide skeleton after done
    }
  };

  const handleToggle = async (slug) => {
    const newStatus = !toggles[slug];
    setToggles((prev) => ({ ...prev, [slug]: newStatus }));

    try {
      setLoading(true);
      await axios.post(`${baseURL}/maintenance-mode`, {
        branch_id,
        slug,
        maintenancemode_status: newStatus ? 0 : 1,
      });
      await fetchCurrentStatus();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleMainToggle = async (menu) => {
    const isAllEnabled = menu.subMenu.every((sub) => toggles[sub.slug]);
    const newStatus = !isAllEnabled;

    const updatedToggles = { ...toggles };
    menu.subMenu.forEach((sub) => {
      updatedToggles[sub.slug] = newStatus;
    });
    setToggles(updatedToggles);

    try {
      setLoading(true);
      await Promise.all(
        menu.subMenu.map((sub) =>
          axios.post(`${baseURL}/maintenance-mode`, {
            branch_id,
            slug: sub.slug,
            maintenancemode_status: newStatus ? 0 : 1,
          })
        )
      );
      await fetchCurrentStatus();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    accordionItem: {
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      overflow: "hidden",
      marginBottom: "10px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    },
    accordionHeader: {
      backgroundColor: "#ffffff",
      padding: "0.75rem 1.5rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      cursor: "pointer",
    },
    toggleSwitch: {
      transform: "scale(1.1)",
      cursor: "pointer",
    },
    sectionTitle: {
      fontWeight: "600",
      fontSize: "1rem",
    },
    labelText: {
      fontWeight: "400",
      fontSize: "1rem",
      color: "#222",
    },
    accordionBody: {
      backgroundColor: "#ffffff",
      padding: "1rem 1.5rem",
    },
    icon: {
      marginRight: "0.5rem",
    },
    statusText: {
      minWidth: "90px",
      textAlign: "right",
    },
  };

  return (
    <>
      {/* Breadcrumb Header */}
      <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
        <div className="mb-0 w-100">
          {initialLoading ? (
            <div>
              <h4 className="breadcrumb-header mb-2">
                <Skeleton width={180} height={20} />
              </h4>
              <ol className="breadcrumb fs-7 d-flex align-items-center gap-2">
                <li className="breadcrumb-item">
                  <Skeleton width={80} height={14} />
                </li>
                <li className="breadcrumb-item">
                  <Skeleton width={100} height={14} />
                </li>
                <li className="breadcrumb-item active">
                  <Skeleton width={90} height={14} />
                </li>
              </ol>
            </div>
          ) : (
            <>
              <h4 className="breadcrumb-header">Maintenance Mode</h4>
              <ol className="breadcrumb fs-7 d-flex align-items-center gap-2">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <i className="fa-solid fa-angles-right fs-8"></i>
                </li>
                <li className="breadcrumb-item active">Monitoring Tools</li>
              </ol>
            </>
          )}
        </div>
      </div>

      {/* Skeleton for Menu List */}
      {initialLoading ? (
        <div>
          {[...Array(4)].map((_, idx) => (
            <div key={idx} style={styles.accordionItem}>
              <div style={styles.accordionHeader}>
                <div className="d-flex align-items-center gap-2">
                  <Skeleton circle width={30} height={30} />
                  <Skeleton width={120} height={18} />
                </div>
                <Skeleton width={80} height={18} />
              </div>
              <div className="card-body" style={styles.accordionBody}>
                <div className="row fw-bold">
                  {[...Array(3)].map((_, i) => (
                    <div
                      key={i}
                      className="col-lg-3 mb-3"
                      style={{
                        border: "1px solid #00000020",
                        borderRadius: "10px",
                        padding: "0.5rem",
                        width: "350px",
                      }}
                    >
                      <Skeleton width={150} height={18} />
                      <Skeleton width={100} height={14} style={{ marginTop: "8px" }} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        // Actual Menu List
        <div>
          {menuList.map((menu) => {
            const menuToggle = toggles[menu.slug] !== undefined ? toggles[menu.slug] : true;
            const isMenuLive =
              menu.subMenu.length > 0
                ? menu.subMenu.every((sub) =>
                    toggles[sub.slug] !== undefined ? toggles[sub.slug] : true
                  )
                : menuToggle;

            return (
              <div
                key={menu.slug}
                className="card"
                style={{
                  ...styles.accordionItem,
                  backgroundColor: isMenuLive ? "#d4edda" : "#ffffff",
                }}
              >
                <div
                  style={styles.accordionHeader}
                  onClick={() => {
                    if (menu.subMenu.length > 0) {
                      setOpenMenus((prev) => ({
                        ...prev,
                        [menu.slug]: !prev[menu.slug],
                      }));
                    }
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <i className={`fas ${menu.icon} fs-4 me-2 text-black`} style={styles.icon}></i>
                    <span style={styles.sectionTitle} className="text-black">
                      {menu.label}
                    </span>
                  </div>

                  <div className="d-flex align-items-center gap-3 fw-bold">
                    <span
                      className={`fs-7 fw-medium ${isMenuLive ? "text-primary" : "text-danger"}`}
                      style={styles.statusText}
                    >
                      {isMenuLive ? "Live" : "Maintenance"}
                    </span>

                    <Form.Check
                      type="switch"
                      id={`${menu.slug}-toggle`}
                      checked={isMenuLive || false}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() =>
                        menu.subMenu.length > 0
                          ? handleMainToggle(menu)
                          : handleToggle(menu.slug)
                      }
                      style={styles.toggleSwitch}
                    />

                    <span style={{ width: "1.25rem", display: "inline-block" }}>
                      {menu.subMenu.length > 0 && (
                        <i
                          className={`fas ${
                            openMenus[menu.slug] ? "fa-chevron-down" : "fa-chevron-up"
                          } fs-4`}
                          style={styles.icon}
                        ></i>
                      )}
                    </span>
                  </div>
                </div>

                {menu.subMenu.length > 0 && openMenus[menu.slug] && (
                  <div className="card-body" style={styles.accordionBody}>
                    <div className="row fw-bold">
                      {menu.subMenu.map((sub) => {
                        const status = toggles[sub.slug] ? "Live" : "Maintenance";
                        const subData = menuStatus[sub.slug];
                        const statusDate = subData
                          ? toggles[sub.slug]
                            ? subData.live_date
                            : subData.maintenance_date
                          : null;

                        let formattedDateTime = "";
                        if (statusDate) {
                          const dateObj = new Date(statusDate);
                          const date = dateObj.toISOString().split("T")[0];
                          formattedDateTime = `${date}`;
                        }

                        return (
                          <div
                            key={sub.slug}
                            className="col-lg-3 mb-3"
                            style={{
                              border: "1px solid #00000080",
                              borderRadius: "10px",
                              padding: "0.5rem",
                              margin: "2px",
                              width: "350px",
                              boxSizing: "border-box",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div className="d-flex justify-content-between align-items-start">
                              <span style={{ ...styles.labelText, fontWeight: 500 }}>
                                {sub.label}
                              </span>
                              <Form.Check
                                type="switch"
                                id={`${sub.slug}-toggle`}
                                checked={toggles[sub.slug] || false}
                                onChange={() => handleToggle(sub.slug)}
                                style={styles.toggleSwitch}
                              />
                            </div>

                            <span
                              className={`fs-7 fw-medium mt-2 ${
                                toggles[sub.slug] ? "text-primary" : "text-danger"
                              }`}
                            >
                              {status}
                              {formattedDateTime
                                ? ` [updated on: ${formattedDateTime}]`
                                : ""}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            );
          })}

          {loading && <div className="text-center mt-3 text-secondary">Updating...</div>}
        </div>
      )}
    </>
  );
};

export default Maintanance_Mode;
